import React, { FC } from 'react'

import { FormattedMessage } from 'react-intl'

import {
  Note,
  Text,
  WrapperCenter,
} from 'components/page/ForeignProfile/Gifts/Gifts.styled'
import { GiftPlusSvg } from 'components/page/ForeignProfile/Gifts/icons/GiftPlusSvg'
import { GQLGender } from 'generated-graphql/graphql'

interface GiftPlaceholderProps {
  gender: GQLGender
}

export const GiftPlaceholder: FC<GiftPlaceholderProps> = ({ gender }) => {
  return (
    <WrapperCenter>
      <Text>
        <GiftPlusSvg />
        <FormattedMessage
          id="send.profile.gift"
          defaultMessage="Подарите {gender, select, M {ему} F {ей} other {ему}} комплимент"
          values={{
            gender,
          }}
        />
      </Text>
      <Note>
        <FormattedMessage
          id="send.profile.gift.attention"
          defaultMessage="Обратите на себя внимание"
        />
      </Note>
    </WrapperCenter>
  )
}
